export const usageActions = {
    create_content_brief: 'create_content_brief',
    create_content_monitor: 'create_content_monitor',
    create_keyword_research: 'create_keyword_research',
    ai_credits_actions: ['run_ai_brief', 'run_ai_outline', 'run_ai_content', 'run_ai_spellchecker'],
};
